import { Input, Output, EventEmitter, Component } from "@angular/core";
import { AttributeModel } from "./model/attribute.model";
import { AttributeService } from "./service/attribute.service";
import { OptionModel } from "./model/option.model";
import { DynamicEvent } from "./dynamic.event";
import { ProcessModel } from "./model/process.model";

@Component({
  template: ''
})
export abstract class DynamicItem {
    @Input() attribute: AttributeModel
    @Input() section: AttributeModel
    @Input() parent: AttributeModel
    @Input() process: ProcessModel
    @Input() envOptions: OptionModel[] = []
    @Output() onEmit: EventEmitter<DynamicEvent[]> = new EventEmitter()
    helper: AttributeService
  
    constructor() {
      this.helper = new AttributeService()
    }

    addToEnvOptions(option: OptionModel) {
      let opt = this.envOptions
          .find(opt => opt.key.toLowerCase() == option.key.toLowerCase())

      if(opt) {
        opt.value = option.value
      } else {
        this.envOptions = [...this.envOptions, option]
      }
    }

    checkViewMode(mode: string): boolean {
      let viewModeOpt = this.attribute.options
          .find(opt => opt.key.toLowerCase() == "viewmode")

      if(viewModeOpt) {
          return viewModeOpt.value.toLowerCase() == mode.toLowerCase()
      }

      let envOption = this.envOptions
          .find(opt => opt.key.toLowerCase() == "viewmode")

      if(envOption) {
          return envOption.value.toLowerCase() == mode.toLowerCase()
      }

      let sessionViewMode = sessionStorage.getItem('typeDynamic')

      if(sessionViewMode) {
          return sessionViewMode.toLowerCase() == mode.toLowerCase()
      }

      return false
    }

    emit(event: DynamicEvent) {
      if(event) {
        this.preProcessEvent(event)
        this.onEmit.emit([event])
      }
    }

    emitEvents(events: DynamicEvent[]) {
      events.forEach(event => {
        this.preProcessEvent(event)
      })

      this.onEmit.emit(events)
    }

    private preProcessEvent(event: DynamicEvent) {
      if(!event.name && event.attribute) {
        event.name = event.attribute.type.toLowerCase()
      }

      let hasUpdateOpt = this.attribute.options
        .some(opt => opt.key.toLowerCase() == "perform front-end update" && 
                     opt.value.toLowerCase() == "true")

      if(event.name == "autosave" || event.name == "save and update") {
        if(this.attribute) {
          if(!this.attribute.options) {
            this.attribute.options = []
          }
          
          let changedByUserOpt = this.attribute.options
            .find(opt => opt.key.toLowerCase() == "changedbyuser")

          if(changedByUserOpt) {
            changedByUserOpt.value = "true"
          } else {
            this.attribute.options.push({
              key: "ChangedByUser",
              value: "true",
              type: "Boolean"
            })
          }
        }

        if(hasUpdateOpt) {
          event.name = "save and update"
        }
      }
    }

    getMask(): string {
      return new AttributeService().getMask(this.attribute)
    }
      
    isRequired(): boolean{
        return  this.helper.isRequired(this.attribute)
    }

    getOptionByKey(attribute: AttributeModel, key: string): string {
      if (!attribute.options || !key) {
        return "";
      }
  
      let opt = attribute.options.find(option => option.key.toLowerCase() == key.toLowerCase());
  
      if (opt)
        return opt.value;
      else
        return "";
    }

    getTitle(): string {
      let titleOpt = this.attribute.options
        .find(opt => opt.key.toLowerCase() == "title")
  
      if(titleOpt) {
        return titleOpt.value
      }
  
      return this.attribute.key
    }
}